import React, { useEffect, useState } from 'react';
import functions from '../../../../functions';
import api from '../../../../api';
import apifunctions from '../../../../api/functions';
import imgNoDisponible from '../../../../../public/img/image-not-found.png';

const baseItem = {
  Imagen: imgNoDisponible,
  Titulo: 'Titulo',
  Subtitulo: 'Subtitulo',
  Link: '',
  Order: 0,
  Width: '',
  Height: '',
};

export const useCarruselItems = () => {
  const [items, setItems] = useState([{ ...baseItem }]);

  const updateItemsArrayLength = (newVal) => {
    setItems(prevItems => {
      let newItems = [...prevItems];
      if (newItems.length < newVal) {
        while (newItems.length < newVal) {
          newItems.push({ ...baseItem });
        }
      } else if (newItems.length > newVal) {
        while (newItems.length > newVal) {
          newItems.pop();
        }
      }
      newItems.forEach((item, i) => {
        item.Order = i + 1;
      });
      return newItems;
    });
  }

  const updateTitle = (index, title) => {
    setItems(prevItems => {
      let newItems = [...prevItems];
      newItems[index].Titulo = title;
      return newItems;
    })
  }
  const updateDescr = (index, subtitle) => {
    setItems(prevItems => {
      let newItems = [...prevItems];
      newItems[index].Subtitulo = subtitle;
      return newItems;
    })
  }
  const updateImage = (index, file) => {
    if (file) {
      const callback = (Imagen) => {
        setItems(prevItems => {
          let newItems = [...prevItems];
          newItems[index].Imagen = Imagen;
          return newItems;
        })
      };
      functions.getB64ImageFromInputFile(file).then(callback).catch(callback);
    };
  }

  const updateOrder = (index, mov) => {
    if ((mov == 1 || mov == -1) && index >= 0 && index < items.length) {
      setItems(prevItems => {
        let newItems = [...prevItems];
        if (mov == -1) {
          let prevItem = newItems[index - 1];
          let item = newItems[index];
          newItems[index - 1] = item;
          newItems[index] = prevItem;
        }
        else if (mov == +1) {
          let nextItem = newItems[index + 1];
          let item = newItems[index];
          newItems[index + 1] = item;
          newItems[index] = nextItem;
        }
        newItems.forEach((item, i) => {
          item.Order = i + 1;
        });
        return newItems;
      });
    }
  }
  const removeItem = (index) => {
    if (index >= 0 && index < items.length) {
      setItems(prevItems => {
        let newItems = [...prevItems].filter((item, itemIndex) => item && index != itemIndex);
        newItems.forEach((item, i) => {
          item.Order = i + 1;
        });
        return newItems;
      });
    }
  }

  const getItems = () => {
    const getAndProcess = (reintento = 0) => {
      const failureCallback = () => {
        if (reintento < 3) getAndProcess(reintento + 1);
        else setItems([]);
      }
      const successCallback = (data) => {
        setItems(data ? data : []);
      }
      apifunctions.get(api.gestion.sitio.carousel, null, null, {}, successCallback, failureCallback, failureCallback);
    }
    getAndProcess();
  };

  const saveItems = (preprocessItems, successCallback, failureCallback) => {
    apifunctions.put(api.gestion.sitio.carousel, null, preprocessItems(items), successCallback, failureCallback, failureCallback);
  }

  useEffect(getItems, []);

  return {
    items,
    setItems,
    updateItemsArrayLength,
    updateTitle,
    updateDescr,
    updateImage,
    updateOrder,
    removeItem,
    getItems,
    saveItems,
  }
}



// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/CarruselImages/useCarruselItems.js